import {
    HomeConfigReponse,
    IPageParams,
    IPageResponse,
    MyQuestionResponse,
    ProjectListItem,
    IHomeQaDataItem,
    IHomeConfig,
    IQaPairDetail,
} from '@/types';
import Http from '@/utils/http';

// 获取问题总数 和 消息待读数
export const getHomePageQuestionOrMessage = (params: { channelSource: number }) =>
    Http.get<{
        questionNum: number; // 提问总数
        notViewQuestionNum: number; // 待查看问题数
    }>(`/athena/api/v1/front/luca-ask/home-page/statistics/question-num`, params);

// 获取首页配置
export const getHomeConfig = (params: { entrySource: string; clientSource: string; sourceMark: string }) =>
    Http.get<HomeConfigReponse>(`/athena/api/v1/front/luca-ask/home-page/config`, params);

// 获取 翻译使用
export const getTaskId = (params: { fileLink: string }) => Http.post('/teaching-workbench/ask/answerLink', params);

export const getTranslateText = (params: { taskId: string }) => Http.get('/teaching-workbench/ask/answerContent', params);

// 获取提问列表项目科目列表
export const getProjectAndSubject = (params: {
    projectId?: number;
    subjectId?: number;
    twoLevelSubjectId?: number; // 二级科目id
    channelSource?: number; // 渠道来源 高顿：100537564 上岸鸭公考：100537563
}) => Http.get<ProjectListItem[]>('/athena/api/v1/front/luca-ask/project/subject/list', params);

// 获取提问列表
export const getMyQuestionList = (params: {
    resourceId?: number;
    courseId?: number;
    projectId?: number; // 项目id
    subjectId?: number; // 科目id
    twoLevelSubjectId?: number; //	二级科目id
    channelSource?: number; // 渠道来源 高顿：100537564 上岸鸭公考：100537563
    lucaId?: number; //	lucaId
    pageSize: number; // 每页数量 默认20
    pageNum: number; //	当前页码
}) => Http.get<MyQuestionResponse>('/athena/api/v1/front/luca-ask/list', params);

// 获取收藏列表项目科目
export const getCollectProject = (params: {
    projectId?: number;
    subjectId?: number;
    twoLevelSubjectId?: number; // 二级科目id
    channelSource?: number; // 渠道来源 高顿：100537564 上岸鸭公考：100537563
}) => Http.get<ProjectListItem[]>('/athena/api/v1/front/luca-ask/collect/project/subject/list', params);

// 获取收藏列表
export const getCollectList = (params: {
    projectId?: number; // 项目id
    subjectId?: number; // 科目id
    twoLevelSubjectId?: number; //	二级科目id
    channelSource?: number; // 渠道来源 高顿：100537564 上岸鸭公考：100537563
    lucaId?: number; //	lucaId
    pageSize: number; // 每页数量 默认20
    pageNum: number; //	当前页码
    questionType?: 0 | 1; // 0:问题 1:知识切片
}) => Http.get<MyQuestionResponse>('/athena/api/v1/front/luca-ask/collect/list', params);

// 获取答疑详情
export const getAnswerDetail = (id: number) => Http.get(`/carefree/api/v1/front/ask/detail?askId=${id}`, {}, { needToastError: false });

// 追问
export const postOtherQuestion = (params: { askId: number; images: string; questionContent: string }) =>
    Http.post('/carefree/api/v1/front/ask/again', params);

// 评价
export const postComment = (params: {
    starLevel: number; // 类型：String  必有字段  备注：评价星级
    content: string; // 类型：String  可有字段  备注：评价内容
    lucaAskChatId?: string; // 类型：String  可有字段  备注：luca答疑过来的必传
    askId?: number; // 类型：Number  可有字段  备注：人工提问问题iD，非luca答疑过来的必传
}) => Http.post('/athena/api/v1/front/luca-ask/appraisal/save', params);

// 更新问题状态
export const postQuestionStatus = (id: number) => Http.post(`/athena/api/v1/front/luca-ask/${id}/question/state`);

// 收藏问题
export const old_comm_collect = (params: { ask_id: number }) =>
    Http.post('/carefree/front/ask/collect/save', params, { needToastError: false });

// 获取老师响应时长
export const getTeacherResponseTime = (params: { subjectId: number }) =>
    Http.get('/athena/api/v1/front/luca-ask/teacher/response/time', params);

// 获取单个问题条目状态
export const getQuestionItemStatus = (id: number) => Http.get(`/athena/api/v1/front/luca-ask/chat/${id}`);

export interface IQueryQaDataParams extends IPageParams {
    projectId: number;
    subjectId: number;
}
// 获取首页qa相关数据
export const query_qa_data = (params: IQueryQaDataParams) =>
    Http.post<IPageResponse<IHomeQaDataItem>>(`/athena/api/v1/front/luca-ask/home-page/everyone/questions/list`, params);

// 获取首页头图、卡片区、金刚位配置信息
export const home_config = (params: {
    /**
     * 是否AI模式
     */
    pageConfig: 1 | 0;
}) => Http.get<IHomeConfig>(`/athena/api/v1/front/luca-ask/home-page/configs`, params);

// qa对详情
export const qa_pair_detail = (params: {
    /**
     * qaID
     */
    qaId: string;
}) => Http.get<IQaPairDetail>(`/athena/api/v1/front/luca-ask/qa/detail`, params, { needToastError: false });
